import { render, staticRenderFns } from "./FormCreateForm.vue?vue&type=template&id=76f5997d&"
import script from "./FormCreateForm.vue?vue&type=script&lang=js&"
export * from "./FormCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports